import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Drawer, useMantineTheme } from "@mantine/core";
import { Resizable } from "re-resizable";
export const MarketplaceDrawer = ({ children, size, minimized, minimizedSize, onSizeChange, ...props }) => {
    const theme = useMantineTheme();
    const [height, setHeight] = useState(size);
    useEffect(() => {
        if (!minimized) {
            setHeight(size);
        }
        else if (minimized && minimizedSize) {
            setHeight(minimizedSize);
        }
    }, [minimizedSize, minimized]);
    useEffect(() => {
        if (height && onSizeChange && height !== size) {
            onSizeChange(height);
        }
    }, [height, onSizeChange, size]);
    return (_jsx(Drawer, { position: "bottom", ...props, closeOnEscape: false, withinPortal: true, lockScroll: false, withCloseButton: false, closeOnClickOutside: false, size: "100%", styles: {
            root: { pointerEvents: "none" },
            overlay: { background: "transparent !important" },
            drawer: {
                padding: "0 !important",
                background: "transparent !important",
            },
            body: {
                height: "100%",
                background: "transparent !important",
                display: "flex",
                alignItems: "flex-end",
            },
        }, children: _jsx(Box, { sx: {
                background: theme.colors.primaryBackground[0],
                width: "100%",
                pointerEvents: "auto",
                borderTop: `1px solid ${theme.colors.divider[0]}`,
            }, children: _jsx(Resizable, { defaultSize: {
                    height: size,
                }, size: { height }, onResizeStop: (e, direction, ref, d) => {
                    setHeight(height + d.height);
                }, enable: { top: true }, boundsByDirection: true, children: children }) }) }));
};
